import Component from 'antd/es/switch';
import 'antd/lib/switch/style';
export default Component;
